import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const getSelectedDate = (state: TInitialState): { weekday: string, from: string, to: string } | undefined => {
    const {
        selected,
        slots,
    } = state;

    if (selected.date && selected.hour) {
        const selectedSlot = slots[selected.date];
        const selectedHour = selectedSlot?.hours[selected.hour];

        if (selectedSlot && selectedHour) {
            return {
                weekday: selectedSlot.weekday,
                from: selectedHour.from,
                to: selectedHour.to,
            };
        }
        return;
    }
    return;
};

export default getSelectedDate;
